import { ref, watch } from 'vue';
import useSettingsGlobals from '@/composables/useSettingsGlobals'

const { $PLATFORM } = useSettingsGlobals()    

export default (initialValue, key) => {
  const returnValue = ref(initialValue);
  let storedValue;
  
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)

  storedValue = urlParams.get(key)

  if (storedValue) {
    returnValue.value = storedValue
  }

  watch(returnValue, (val) => {
    if ($PLATFORM === 'android') {
      const params = [key, val.toString()]

      alert(params.join(','))
    } else {
      const info = {
        type: key,
        value: val
      }

      window.webkit.messageHandlers.observe.postMessage(info)
    }
  }, {
    deep: true
  })

  return returnValue
}